import { css, keyframes } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

const growProgress = keyframes({
    from: {
        backgroundPositionX: "0"
    },
    to: {
        backgroundPositionX: "100%"
    }
});

const scrollIndicatorLineStyle = css({
    insetBlockEnd: "13px",
    insetInlineStart: 0,
    insetInlineEnd: 0,
    margin: "auto",
    width: "80%",
    height: "10px",
    position: "sticky",
    backgroundColor: wacToken("color.neutral.light800"),
    backgroundImage: `linear-gradient(${wacToken(
        "color.primary.blue"
    )}, ${wacToken("color.primary.blue")})`,
    backgroundSize: "100px 100%",
    backgroundPositionY: "center",
    backgroundPositionX: "0",
    backgroundRepeat: "no-repeat",
    borderRadius: "50px",
    animationName: growProgress,
    animationTimeline: "scroll()",
    animationDuration: "auto",
    animationTimingFunction: "linear",
    animationFillMode: "forwards"
});

export const StickyWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0",
                maxWidth: "100%",
                position: "sticky",
                margin: "0 auto",
                top: 0,
                left: 0
            }}
        >
            {children}
        </div>
    );
};

export const TeamWorkScrollIndicator = ({
    children
}: {
    children: React.ReactNode;
}) => {
    return (
        <div
            style={{
                position: "relative",
                paddingBottom: "50px",
                backgroundColor: wacToken("color.primary.black")
            }}
        >
            {children}

            <div
                css={scrollIndicatorLineStyle}
                className="scroll-indicator-line"
            />
        </div>
    );
};
